import api from "../api/axios";

/**
 * Fetch the Business Overview report.
 * @param {Object} filters - { start_date, end_date }
 */
export const getBusinessOverview = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined
    )
  );
  const response = await api.get("/reports/business-overview", { params });
  return response.data;
};
